import { useTranslation } from 'react-i18next';

import TimestampTooltip from '@/components/atoms/TimestampTooltip/TimestampTooltip';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import {
  getNextActionShortLabel,
  NEXT_ACTION_DOT_COLOR,
} from '@/modules/campaigns/util/nextAction';
import { NextAction } from '@/shared/types/campaigns';

export const NextActionCell = ({
  nextAction,
  timeZone,
}: {
  nextAction?: NextAction;
  timeZone?: string;
}) => {
  const { t } = useTranslation();
  if (!nextAction) {
    return null;
  }

  const badge = (
    <Badge
      type="outline"
      flavour={nextAction.state === 'nothing_scheduled' ? 'warning' : 'neutral'}
      rounded={false}
      className="max-w-full gap-1.5"
    >
      <span
        className={cn('size-2 shrink-0 rounded-full', NEXT_ACTION_DOT_COLOR[nextAction.state])}
      />
      <span className="truncate">{getNextActionShortLabel(t, nextAction, timeZone)}</span>
    </Badge>
  );

  if (!nextAction.due_at) {
    return badge;
  }
  return <TimestampTooltip timestamp={nextAction.due_at}>{badge}</TimestampTooltip>;
};
